import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: string = null

export const appModeSlice = createSlice({
  name: 'appMode',
  initialState,
  reducers: {
    setAppMode: (state, action: PayloadAction<string>) => action.payload,
  },
})

export const { setAppMode } = appModeSlice.actions

export default appModeSlice.reducer
